import { MantineThemeOverride } from '@mantine/core';

export const theme: MantineThemeOverride = {
  colors: {
    brand: [
      '#a3adbe',
      '#31476d',
      '#485c7d',
      '#5f708e',
      '#76859e',
      '#8d99ae',
      '#1A335D',
      '#1A335D',
      '#d1d6df',
      '#e8ebef',
    ],
    secondary: [
      '#f9ecb1',
      '#f2d54f',
      '#f3d962',
      '#f5de76',
      '#f6e389',
      '#f8e89d',
      '#F0D03B',
      '#fbf1c4',
      '#fcf6d8',
      '#fefaeb',
    ],
    secondaryGray: [
      '#F0F2F5',
      '#D4DBE2',
      '#B9C4D0',
      '#9DADBE',
      '#8296AB',
      '#668099',
      '#000000',
      '#3D4D5C',
      '#29333D',
      '#141A1F',
    ],
    secondaryBlue: [
      '#EBF0FA',
      '#C7D6F0',
      '#A3BBE6',
      '#7EA1DC',
      '#5A87D3',
      '#366CC9',
      '#C7D6F0',
      '#204179',
      '#162B50',
      '#0B1628',
    ],
    secondaryRed: [
      '#FDE7E7',
      '#FABCBC',
      '#F79191',
      '#F46666',
      '#F13C3C',
      '#EE1111',
      '#FABCBC',
      '#8F0A0A',
      '#5F0707',
      '#300303',
    ],
  },
  primaryColor: 'brand',
};
